import React, { Component } from 'react';
import {Form, FormLayout, TextField, Select} from "@shopify/polaris";
import './signup.css';
import {reqPartnerType} from "../../api/index";
import ProgressBall from '../../components/progress_ball/progress_ball'

export default class SignupStepTwo extends Component {
    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {

        if (this.props.info.partner_type_option.length === 0 ) {
            reqPartnerType().then(
                response => {
                    let option = [];
                    for(let index in response.data.success)
                    {
                        let item = {};
                        item.label = response.data.success[index]['label'];
                        item.value = response.data.success[index]['value'];
                        option.push(item);
                    }
    
                    this.handleInputChange('partner_type_option', option);
                }
            ).catch(
                error => {
                    console.log(error);
                }
            )
        }

    }

    handleInputChange(name, val) {
        this.props.onChange(this, name, val)
     }

    render() {
        return (
            <>
                <ProgressBall step='2'/>
                <h1>Tell us a little about yourself</h1>
                <h2>Are you a Shopify expert, app provider, influencer, other?</h2>
                <Form onSubmit={this.handleSubmit}>
                    <FormLayout>
                        <Select label="Partner type" value={this.props.info.partner_type} placeholder="Select..." options={this.props.info.partner_type_option} onChange={val => this.handleInputChange('partner_type', val) } error={this.props.info.partner_type_error} />
                        <TextField type="text" label="How do you plan to promote SEO Master?" multiline={4} value={this.props.info.partner_plan_of_promote} onChange={val => this.handleInputChange('partner_plan_of_promote', val) } error={this.props.info.partner_plan_of_promote_error} />
                    </FormLayout>
                </Form>
            </>
        );
    }
}
